export default __webpack_public_path__ + "static/media/lion_standup.0438d6c7.png";